import userInfo from "../../function/userInfo";
import { GetSocketSessionIdFromCookies } from "../../helper/notificationHelper";
import * as API from "../ApiConfig";

export default {
  DoGetUnseenNotificationCount(merchantId) {
    const headers = userInfo.SetHeaderService().headers;
    const input = {
      notificationMerchantId: merchantId,
      socketSessionId: GetSocketSessionIdFromCookies(),
    };

    return API.peakAPI
      .post("/api/Notification/GetUnseenNotificationCount", input, headers)
      .then((res) => {
        return res;
      });
  },
  DoGetUnseenNotificationList(merchantId) {
    const headers = userInfo.SetHeaderService().headers;
    const input = {
      notificationMerchantId: merchantId,
      socketSessionId: GetSocketSessionIdFromCookies(),
    };

    return API.peakAPI.post("/api/Notification/GetUnseenNotificationList", input, headers).then((res) => {
      return res;
    });
  },
  DoGetSeenNotificationList(merchantId) {
    const headers = userInfo.SetHeaderService().headers;
    const input = {
      notificationMerchantId: merchantId,
      socketSessionId: GetSocketSessionIdFromCookies(),
    };

    return API.peakAPI.post("/api/Notification/GetSeenNotificationList", input, headers).then((res) => {
      return res;
    });
  },
  DoGetUnseenNotification(merchantId, notificationId) {
    const headers = userInfo.SetHeaderService().headers;
    const input = {
      id: notificationId,
      notificationMerchantId: merchantId,
      socketSessionId,
    };
    return API.peakAPI.post("/api/Notification/GetUnseenNotification", input, headers).then((res) => {
      return res;
    });
  },
  DoDeleteSeenNotification(merchantId, notificationId) {
    const headers = userInfo.SetHeaderService();
    const input = {
      id: notificationId,
      notificationMerchantId: merchantId,
      socketSessionId: GetSocketSessionIdFromCookies(),
    };
    return API.peakAPI.post("/api/Notification/DeleteSeenNotification", input, headers).then((res) => {
      return res;
    });
  },
  DoDeleteUnseenNotification(merchantId, notificationId) {
    const headers = userInfo.SetHeaderService();
    const input = {
      id: notificationId,
      notificationMerchantId: merchantId,
      socketSessionId: GetSocketSessionIdFromCookies(),
    };
    return API.peakAPI.post("/api/Notification/DeleteUnseenNotification", input, headers).then((res) => {
      return res;
    });
  },
  DoSetNotificationIsSeen(merchantId, notificationId) {
    const headers = userInfo.SetHeaderService();
    const input = {
      id: notificationId,
      notificationMerchantId: merchantId,
      socketSessionId: GetSocketSessionIdFromCookies(),
    };
    return API.peakAPI.post("/api/Notification/SetNotificationIsSeen", input, headers).then((res) => {
      return res;
    });
  },
  DoSetAllNotificationIsSeen(merchantId) {
    const headers = userInfo.SetHeaderService();
    const input = {
      notificationMerchantId: merchantId,
      socketSessionId: GetSocketSessionIdFromCookies(),
    };
    return API.peakAPI.post("/api/Notification/SetAllNotificationIsSeen", input, headers).then((res) => {
      return res;
    });
  },
};
